import firebase from "../../modules/firebase/firebase";
import { collection, addDoc, getFirestore } from "@firebase/firestore";

import React from "react";
import ReactDOM from "react-dom";

const base_phone = new RegExp("(\\+84|0){1}(9|8|7|5|3){1}[0-9]{8}");

const db = getFirestore();

class MectopOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      database: collection(db, "projects", "4FfiC9GpWqKW4a56PAJz", "orders"),
      origin: Object.assign({}, window.mectop, {
        status: "0",
        src: window.location.href,
      }),
      forms: false,
      event_forms: false,
      data: {},
    };
  }

  componentDidMount() {
    var forms = Array.from(document.querySelectorAll("form"));
    Array.from(document.querySelectorAll("iframe")).forEach((_iframe) => {
      try {
        var form_from_iframe = Array.from(
          _iframe.contentWindow.document.querySelectorAll("form")
        );
        if (form_from_iframe) {
          forms = forms.concat(...form_from_iframe);
        }
      } catch (err) {
        console.log(err);
      }
    });
    this.setState({ forms: forms });
  }

  handleInput = (event) => {
    var e_name = event.target.name;
    var e_value = event.target.value;
    this.setState({
      data: Object.assign({}, this.state.data, {
        [e_name]: e_value,
      }),
    });
    if (e_name == "phone" && base_phone.test(e_value)) {
      if (this.state.capture_form) {
        clearTimeout(this.state.capture_form);
      }
      this.setState({
        capture_form: setTimeout(() => {
          this.handleSubmit("event", true);
        }, 5 * 60 * 1000 - 10),
      });
    }
  };

  send_order = async (data) => {
    try {
      console.log("Dang upload");
      return await addDoc(this.state.database, data);
    } catch (err) {
      console.log(err);
    }
  };

  handleSubmit = (event, capture = false) => {
    if (
      this.state.data.hasOwnProperty("phone") &&
      base_phone.test(this.state.data.phone)
    ) {
      const current = Date.now();
      var new_data = {
        created_time: current,
        last_updated: current,
      };
      if (capture) {
        new_data["capture_form"] = true;
      }
      ["owner", "items", "status", "src"].forEach((_field) => {
        if (this.state.origin.hasOwnProperty(_field)) {
          new_data[_field] = this.state.origin[_field];
        }
      });
      ["name", "phone", "address", "note"].forEach((_field) => {
        if (this.state.data.hasOwnProperty(_field)) {
          new_data[_field] = this.state.data[_field];
        }
      });
      console.log(this.send_order(new_data).then((doc) => doc.id));
    }
  };

  componentDidUpdate() {
    if (!this.state.event_forms && this.state.forms) {
      this.state.forms.forEach((_form) => {
        Array.from(_form.querySelectorAll("input, select")).forEach((_input) =>
          _input.addEventListener("change", (event) => this.handleInput(event))
        );
        _form.addEventListener("submit", (event) => this.handleSubmit(event));
      });
      this.setState({ event_forms: true });
    }
    console.log(this.state.data);
  }
  render() {
    return <span></span>;
  }
}

// window.onload = () => {
// };
setTimeout(() => {
  document.body.insertAdjacentHTML(
    "beforeend",
    "<div id='mectop-orders'></div>"
  );
  ReactDOM.render(<MectopOrder />, document.getElementById("mectop-orders"));
}, 5000);
